import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useTransition,
} from "react";
import {
  linear_content_style,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import { useLocation } from "react-router-dom";
import {
  FieldValues,
  FormProvider,
  useForm,
  UseFormReturn,
} from "react-hook-form";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { Toast } from "../../../libs/app-core/Toast";
import { useAppContext } from "../../../libs/app-core/AppContext";
import {
  Is連動排除的題目,
  UniQuestion,
  ValidWhenRule,
} from "../../dao/UniQuestion";
import { UniForm } from "../../dao/UniForm";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSpwkQuestV3 } from "../FrmSpwkQuestV3/useSpwkQuestV3";
import { GVContext } from "../../GV";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { YupSchemaBuilder } from "./YupSchemaBuilder";
import { UiMetaTable, UiMetaTableContext } from "../FrmSpwkQuestV3/UiMetaTable";
import UcDevTools from "./UcDevTools";
import { ValueChangedListener } from "./ValueChangedListener";
import UcTabStepContent, { GetSpwkTabSteps } from "./UcTabStepContent";
import { SpwkMetaData_DataType } from "../../export_spwk/SpwkMetaData";
import _ from "lodash";
import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";
import LogoutIcon from "@mui/icons-material/Logout";
import Label from "../../../libs/rhf-mui/ui/Label";
import AuthHelper from "../../heplers/AuthHelper";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";
import { UcHumanBodyImage_ClearValues } from "../../components/uni/UcHumanBodyImage";
import { useMember } from "../../dao/MemberDAO";
import { Member } from "../../dao/Member";
import { UseProject_ws } from "../../dao/ProjectDAO";
import { useTranslation } from "react-i18next";
import { env } from "process";
import LanguageSelector from "../../components/LanguageSelector";
import MemberNavbar from "../../components/MemberNavbar";

/** 此頁面的輸入參數(預計透過url控制) */
export type FrmSpwkQuestProps = {
  answer_guid?: string;
  func_guid?: string;
};

export const FrmSpwkQuestionnaire_Context = createContext<null | {
  _SpwkBaseForm: UniForm | null | undefined;
  _UniFormList: UniForm[] | undefined;
  LangA: Lang;
  set_LangA: React.Dispatch<React.SetStateAction<Lang>>;
  LangB: Lang;
  set_LangB: React.Dispatch<React.SetStateAction<Lang>>;
}>(null);

type Props = {};

const FrmSpwkQuestionnaire = (props: Props) => {
  //#region 讀取網址參數
  let params = useLocation().state;
  let answer_guid = params.answer_guid ?? undefined;
  let func_guid = params.func_guid ?? undefined;

  if (func_guid != null) {
    throw new_ErrorAlert("目前 func_guid 應該要是 undefined !!!"); // 之後再補上各自開啟的功能
  }
  //#endregion

  let YUP_MODE = 2; // 0:不驗證(測試用)、2改版後的驗證

  const ctx = useAppContext();
  const GV = useContext(GVContext);

  const [LangA, set_LangA] = useState<Lang>("CHI");
  const [LangB, set_LangB] = useState<Lang>("");

  const [IsV3Split, set_IsV3Split] = useState(true); // 是否使用新版拆分
  const [IsRemoveEmptyQuestion, set_IsRemoveEmptyQuestion] = useState(true); // 是否移除沒有項目的題目
  const [IsAdjustOptions, set_IsAdjustOptions] = useState(true); // 依照 一般選項, 其他, 無 排序
  const [IsJudgeGender, set_IsJudgeGender] = useState(true); // 依照 一般選項, 其他, 無 排序

  const [IsSkipValid, set_IsSkipValid] = useState(false); // 跳過數值驗證
  const [IsSkipSave, set_IsSkipSave] = useState(false); // 換頁時不儲存

  const { t, i18n } = useTranslation();

  /* 核心變數: 此 Answer 與其通用問題 + 特作版本列表 */
  let { _UniAnswer, _SpwkBaseForm, _UniFormList } = useSpwkQuestV3(
    answer_guid,
    func_guid,
    IsV3Split /* IsV3Split - 是否使用新版拆分 */,
    IsRemoveEmptyQuestion /* IsRemoveEmptyQuestion - 是否移除沒有項目的題目 */,
    IsAdjustOptions /* IsAdjustOptions - 依照 一般選項, 其他, 無 排序 */,
    IsJudgeGender
  ); // $$$

  const BLANK_YUP_SCHEMA = yup.object().shape({});
  let [YupSchema, set_YupSchema] = useState<any>(BLANK_YUP_SCHEMA);
  let member: Member | undefined;
  let guid: string | undefined;
  let project_guid: string | undefined;

  if (_UniAnswer !== null && _UniAnswer !== undefined) {
    guid = _UniAnswer.member_guid;
  }

  const { _Member } = useMember(guid);

  if (_Member !== null && _Member !== undefined) {
    member = _Member;
    project_guid = _Member.project_guid;
  }
  const { _Project } = UseProject_ws(project_guid);

  const rhf = useForm<any>({
    // react-hook-form
    resolver: yupResolver(YupSchema),
  });

  const [_UiMetaTable, set_UiMetaTable] = useState<UiMetaTable | undefined>(
    undefined
  );
  useEffect(() => {
    /** Init UiMetaTable - 準備好一張UI大表，方便 OnRhfValueChanged() 時，連動改變其他元件 */

    if (_SpwkBaseForm != null && _UniFormList != null) {
      let meta_table = new UiMetaTable();

      let chapters: string[] = [];
      if (_SpwkBaseForm.AllQuestions != null) {
        chapters = chapters.concat(
          _SpwkBaseForm.AllQuestions.map((x) => x.chapter)
        );
      }

      for (const spwk_form of _UniFormList) {
        if (spwk_form.AllQuestions != null) {
          chapters = chapters.concat(
            spwk_form.AllQuestions.map((x) => x.chapter)
          );
        }
      }

      chapters = chapters.filter(
        (value, index, array) => array.indexOf(value) === index
      ); // 不重複的

      for (const chapter of chapters) {
        let questions: UniQuestion[] = SpwkUtil.GetChapterQuestionsV3(
          chapter,
          _SpwkBaseForm,
          _UniFormList
        );

        let meta_list = UiMetaTable.ConvertQuestionToMetaList(questions);

        meta_table.ConcatMetaList(meta_list);
      }

      set_UiMetaTable(meta_table);
    }
  }, [_SpwkBaseForm, _UniFormList]);

  //#region
  useEffect(() => {
    // $$$ Watch - OnRhfValueChanged()、OnValueChanged() 監聽數值改變時連動其他數值的部分
    const subscription = rhf.watch((value, { name, type }) => {
      if (IsSkipValid) {
        // pass;
      } else {
        let yup = CreactYupSchma();
        set_YupSchema(yup);
      }

      ValueChangedListener.OnWatch(ctx, _UiMetaTable, rhf, value, name, type);
    });

    return () => {
      subscription.unsubscribe();
      return;
    };
  }, [rhf.watch, _UiMetaTable, []]); // 這裡放 _UiMetaTable 可能是錯的
  //#endregion

  useEffect(() => {
    if (IsSkipValid) {
      // pass;
    } else {
      let yup = CreactYupSchma();
      set_YupSchema(yup);
    }
  }, [i18n.language]);

  // 這裡指的是，A01、A98

  // ----------------------------------------------------------------

  // #region UI 相關
  const [, setScrollTarget] = useState(undefined); // 捲到指定位置用
  // #endregion
  /* 取得當前頁面 */
  const uni_func_guids =
    _UniFormList == null ? [] : _UniFormList?.map((x) => x.func_guid);
  const TabSteps = GetSpwkTabSteps(uni_func_guids, GV?.IsAdmin() ?? false);

  //#region 上一頁、下一頁 與 指定卷軸位置相關方法
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = TabSteps.length;
  const [isSubmitting, setIsSubmitting] = useState(false);

  function render_Next_Prev() {
    return (
      <Typography component="div" sx={{ mt: 4, mb: 2 }}>
        <MobileStepper
          variant="text"
          position="static"
          steps={maxSteps}
          activeStep={activeStep}
          nextButton={
            <Button
              type="submit"
              size="medium"
              disabled={activeStep === maxSteps - 1 || isSubmitting === true}
            >
              {t("下一頁")}{" "}
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button
              size="medium"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              {t("上一頁")}
            </Button>
          }
        />
      </Typography>
    );
  }

  const handleNext = (event: any) => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    //卷軸滾到最上面
    scroll_to_top(event);
  };

  const handleBack = (event: any) => {
    //從page2 回 page1 時 page2 的 schema先清空
    set_YupSchema(BLANK_YUP_SCHEMA);

    setActiveStep((prevActiveStep) => prevActiveStep - 1);

    //卷軸滾到最上面
    scroll_to_top(event);
  };

  /** 換頁時， 捲到最上方 */
  function scroll_to_top(event: any) {
    // const timer =
    setTimeout(() => {
      const anchor = document.querySelector("#back-to-top-anchor");
      if (!anchor) {
        return;
      }
      anchor.scrollIntoView({ block: "center" });
    }, 500);
  }

  function scroll_to_error_message(errors: any, event: any) {
    const timer = setTimeout(() => {
      //錯誤訊息的元素 ClassName 是 .Mui-error
      const error_message = document.querySelector(".Mui-error");
      if (!error_message) {
        return;
      }

      error_message.scrollIntoView({ block: "center" });
    }, 500);
  }

  //#endregion

  function CreactYupSchma() {
    if (IsSkipValid) {
      Toast.ShowDanger(ctx, t("[DEBUG] 略過驗證"));
      // 不使用YUP驗證，方便開發測試
      return BLANK_YUP_SCHEMA;
    }

    if (
      _UniAnswer === undefined ||
      _SpwkBaseForm === undefined ||
      _UniFormList === undefined
    ) {
      return BLANK_YUP_SCHEMA;
    }
    if (_Project === undefined || _Project === null) {
      throw new_ErrorAlert(t("712638 project為空"));
    }
    //#region 在此補上此頁的 yup 驗證
    if (YUP_MODE === 0) {
      // 不使用YUP驗證，方便開發測試
      return BLANK_YUP_SCHEMA;
    } else if (YUP_MODE === 1) {
      alert(t("YUP_MODE===1 不存在!!!"));
      return BLANK_YUP_SCHEMA;
    } else if (YUP_MODE === 2) {
      if (_SpwkBaseForm == null) {
        throw new_ErrorAlert("464131 _SpwkBaseForm==null !!!");
      }
      // FIXME 改為從正確的地方取得(此處如果語言是英文可能會錯誤!!!)
      const uc_title: Element | null = document.querySelector(".uc_title");
      const chapter: any =
        uc_title?.id === "檢查時期(原因)"
          ? SpwkUtil.CHAPTER_檢查時期
          : uc_title?.id;

      const yup_schema = YupSchemaBuilder.CreateByChapter(
        rhf,
        chapter,
        _SpwkBaseForm,
        _UniFormList,
        _Project
      );
      return yup_schema;
    } else {
      throw new_ErrorAlert(t("未知的 YUP_MODE !!!"));
    }
    //#endregion
  }

  useEffect(() => {
    // Init: 讀取檔案 Answer
    if (_UniAnswer == null) {
      return; //查無資料
    }

    if (
      _UniAnswer === undefined ||
      _SpwkBaseForm === undefined ||
      _UniFormList === undefined
    ) {
      return; // 還沒撈資料
    }

    const yup_schema = CreactYupSchma();
    set_YupSchema(yup_schema);

    let rhf_data = _UniAnswer.ConvertToSpwkRhfData();

    rhf.reset(rhf_data); // 讀檔。 將數值填入 rhf
  }, [
    _SpwkBaseForm,
    _UniFormList,
    activeStep,
    _UniAnswer == null
      ? null
      : _UniAnswer === undefined
      ? undefined
      : _UniAnswer.guid,
  ]);

  async function SaveData(data: any, event: any) {
    if (isSubmitting) return; // 防止重複提交

    setIsSubmitting(true);

    try {
      if (_UiMetaTable == null) {
        throw new_ErrorAlert("64643164 _UiMetaTable==null !!!");
      }

      清空連動後看不到的選項(rhf, _UiMetaTable, data);

      data = SpwkUtil.僅保留有Data中有輸入的數值(data);

      if (_UniAnswer == null) {
        alert("_UniAnswer==null");
        return;
      } else {
        if (IsSkipSave) {
          Toast.ShowDanger(ctx, t("[DEBUG] 略過存檔"));
        } else {
          _UniAnswer.SetValueBySpwkRhfData(_UniAnswer.member_guid, data);
          await UniAnswerDAO.WS_Update(_UniAnswer);

          Toast.ShowScuccess(ctx, t("儲存成功"));
        }
      }

      handleNext(event);
    } catch {
      MessageDialog.Show(ctx, "", t("儲存失敗"), {
        ...DialogButtons.Error,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  function OnInvalid(errors: any, event: any) {
    let error_messages: string[] = GetErrorMessages(errors);

    if (error_messages.length !== 0) {
      // 有全表的驗證錯誤
      MessageDialog.Show(ctx, error_messages.join("\n"), t("資料驗證失敗"), {
        colorMeaning: "Warning",
        onDialogResult(e) {
          Toast.ShowWarning(ctx, t("請修正"));
          scroll_to_error_message(errors, event);
        },
      });
    } else {
      // 一般驗證錯誤
      Toast.ShowWarning(ctx, t("回答不完整! 請補充"));
      scroll_to_error_message(errors, event);
    }
  }

  //#region Blocker: 變數尚未準備好
  if (_UniAnswer == null || _SpwkBaseForm == null || _UniFormList == null) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題，貌似是因為<>{"Loading..."}</>改成<>"Loading..."</>好像就可以了
    return <></>;
  }
  //#endregion

  return <>{render_Detail()}</>;

  function btn_Logout_Click() {
    if (GV == null) {
      throw new_ErrorAlert("ERROR! GV==null !!!");
    }

    AuthHelper.Logout(GV, ctx);
  }

  function render_header() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              pl: 2,
            }}
          >
            <Label variant="subtitle2" component="div" sx={{ flexGrow: 1 }}>
              {t("健檢基本資料問卷")}
            </Label>

            <MemberNavbar />
          </Box>
        </AppBar>
      </Box>
    );
  }

  function render_Detail(): React.ReactNode {
    return (
      <>
        <Box
          style={linear_content_style}
          sx={{ bgcolor: "gray" }}
          ref={(node) => {
            if (node) {
              setScrollTarget(node as any);
            }
          }}
        >
          {render_Quest()}
        </Box>
      </>
    );
  }

  function render_Quest() {
    return (
      <Box style={linear_content_style}>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_header()}</Grid>

          <Grid {...linear_item} flex={1}>
            <Box
              style={linear_content_style}
              sx={{ backgroundColor: { xs: "#ffffff", sm: "#eff0f4" } }}
            >
              <FrmSpwkQuestionnaire_Context.Provider
                value={{
                  _SpwkBaseForm,
                  _UniFormList,
                  LangA,
                  set_LangA,
                  LangB,
                  set_LangB,
                }}
              >
                <Container maxWidth="lg" sx={{ mx: "auto" }}>
                  <Box id="back-to-top-anchor" sx={{ height: "1.5em" }} />

                  <UiMetaTableContext.Provider
                    value={{ _UiMetaTable, OriRhfData: null, member }}
                  >
                    <FormProvider {...rhf}>
                      {/* DebugTools */}
                      {GV?.IsAdmin() === true ? (
                        <UcDevTools
                          _UniAnswer={_UniAnswer}
                          _UniFormList={_UniFormList}
                          IsV3Split={IsV3Split}
                          set_IsV3Split={set_IsV3Split}
                          IsRemoveEmptyQuestion={IsRemoveEmptyQuestion}
                          set_IsRemoveEmptyQuestion={set_IsRemoveEmptyQuestion}
                          IsAdjustOptions={IsAdjustOptions}
                          set_IsAdjustOptions={set_IsAdjustOptions}
                          IsSkipValid={IsSkipValid}
                          set_IsSkipValid={set_IsSkipValid} // 跳過數值驗證
                          IsSkipSave={IsSkipSave}
                          set_IsSkipSave={set_IsSkipSave} // 換頁時不儲存
                          IsJudgeGender={IsJudgeGender}
                          set_IsJudgeGender={set_IsJudgeGender} // 換頁時不儲存
                          OnSkipValidChanged={(check: boolean) => {
                            if (check === true) {
                              set_YupSchema(BLANK_YUP_SCHEMA); // 測試用，清空 YupSchema
                            } else {
                              const yup_schema = CreactYupSchma();
                              set_YupSchema(yup_schema);
                            }
                          }}
                        />
                      ) : undefined}

                      <form
                        onSubmit={rhf.handleSubmit(
                          (data: any, event: any) => {
                            SaveData(data, event);
                          },
                          (errors: any, event: any) => {
                            OnInvalid(errors, event);
                          }
                        )}
                      >
                        <Grid
                          px={{ sm: 6 }}
                          mt={{ xs: 0, sm: 3 }}
                          pt={{ xs: 0, sm: 6 }}
                          mb={{ xs: 4, sm: 8 }}
                          container
                          direction="column"
                          boxShadow={{ sm: 3 }}
                          sx={{ backgroundColor: "#fff" }}
                        >
                          {/* 切頁 */}
                          <Box sx={{ flexGrow: 1 }}>
                            <Paper
                              square
                              elevation={0}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: 0,
                              }}
                            ></Paper>
                            <Box sx={{ height: "auto", px: 2 }}>
                              {/* $$$ 繪製題目 */}
                              {
                                <UcTabStepContent
                                  tab_step={TabSteps[activeStep]}
                                  _SpwkBaseForm={_SpwkBaseForm}
                                  _UniFormList={_UniFormList}
                                  _UniAnswer={_UniAnswer}
                                  _Member={member}
                                />
                              }
                            </Box>
                            {render_Next_Prev()}
                          </Box>
                        </Grid>
                      </form>
                    </FormProvider>
                  </UiMetaTableContext.Provider>
                </Container>
              </FrmSpwkQuestionnaire_Context.Provider>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
};

export default FrmSpwkQuestionnaire;

export function 清空連動後看不到的選項(
  rhf: UseFormReturn<FieldValues, any>,
  _UiMetaTable: UiMetaTable,
  data: any
) {
  for (const meta of _UiMetaTable.meta_rows) {
    if (meta.data_type === SpwkMetaData_DataType.Question) {
      let question = meta.data_obj as UniQuestion;
      if (question.valid_when_rule !== ValidWhenRule.None) {
        let is_lock = Is連動排除的題目(question, rhf); // Hide
        if (is_lock) {
          if (question.kind === SpwkUtilV3.Q_KIND_單選) {
            _.set(data, meta.rhf_name, undefined);
          }

          if (question.kind === SpwkUtilV3.Q_KIND_多選) {
            let option_metas = _UiMetaTable.FilterOptionMetas_ByQuestionGuid(
              question.guid
            );
            for (const option_meta of option_metas) {
              let rhf_name = option_meta.rhf_name;
              _.set(data, rhf_name, undefined);
            }
          }

          let input_metas = _UiMetaTable.FilterInputMetas_ByQuestionGuid(
            question.guid
          );
          for (const item_meta of input_metas) {
            let rhf_name = item_meta.rhf_name;
            _.set(data, rhf_name, undefined);
          }

          if (question.kind === SpwkUtilV3.Q_KIND_自訂) {
            if (question.question_title === SpwkUtilV3.UcHumanBodyImage) {
              UcHumanBodyImage_ClearValues(data); // 清空人體圖答案
            }
          }
        }
      }
    }
  }
}
/*
* 這裡預計取得全表例外驗證後的錯誤訊息
* 目前只對 章節內的 input 有效
* 如果要單選 或 多選，要再補上

* YupSchemaBuilder.YupGlobalValidation() 產出的驗證
*/
function GetErrorMessages(errors: any) {
  let error_messages: string[] = [];

  let chapters = Object.keys(errors); // 最外層是章節
  if (chapters != null) {
    for (const chapter of chapters) {
      let keys = Object.keys(errors[chapter]); // 先簡單驗證 input錯誤，type==="FORM" 的全表例外驗證

      for (const key of keys) {
        let error = errors[chapter][key];

        if (
          error != null &&
          error.type != null &&
          error.type === SpwkUtilV3.YUP_ERROR_TYPE_FROM
        ) {
          error_messages.push(error.message ?? "");
        }
      }
    }
  }

  return error_messages;
}
